<template>
	<div class="map-info" :class="{ 'is-active': visible, 'is-empty': computedLocalEventList.length === 0 }">
		<div class="map-info-header">
			<button type="button" class="btn-close" @click="onClickClose()">
				<i class="icon-close">팝업닫기</i>
			</button>
		</div>
		<div class="swiper-festival-container">
			<div v-if="computedLocalEventList.length === 0" class="festival-empty-msg">
				<p style="text-align: center; font-size: 18px; color: #000; font-weight: 500;"></p>
				<button v-if="localMallOnlyUrl" type="button" class="btn-shortcut-page" style="margin-top: 20px;" @click="openLocalMall">
					지자체몰
					<span>지역 특산품을 온라인으로 구매해보세요!</span>
				</button>
			</div>
			<template v-else>
				<swiper ref="swiper" class="swiper" :options="swiperOption" @slideChange="onSwiperChange">
					<swiper-slide v-for="(item, idx) in computedLocalEventList" :key="idx">
						<div class="festival-item">
							<!-- <strong class="festival-item-area">
								{{ item.arNm }}
							</strong>
							<span class="festival-item-img">
								<img :src="item.imgFileUrl" :alt="item.arEventNm" />
							</span> -->
							<div class="festival-item-text">
								<strong class="festival-item-title text-ellipsis-2">{{ item.arEventNm }}</strong>
								<dl class="festival-item-dl">
									<dt>기간</dt>
									<dd>{{ item.date }}</dd>
								</dl>
								<dl class="festival-item-dl">
									<dt>장소</dt>
									<dd>{{ item.plcInfo }}</dd>
								</dl>
								<dl class="festival-item-dl">
									<dt>소개</dt>
									<dd>{{ item.eventIntro }}</dd>
								</dl>
							</div>
							<!-- <button type="button" class="more-festival" @click="onClickMoveFestival($event, item)">축제 자세히 보기 <i><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M8 5L16 12L8 19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg></i></button> -->
						</div>
					</swiper-slide>
				</swiper>
				<div class="festival-item-footer">
					<!-- :href="item.rltdUrl"  -->
					<!-- <a v-if="!!item.rltdUrl" 
						target="_blank" class="button-arrow-r" title="새창열림"
						@click="onClickMoreInfo($event, item)"
					>
						더보기
						<i class="icon"><icon name="icon-arrow-r" /></i>
					</a> -->
					<button v-if="regionMallUrl" type="button" class="btn-shortcut-page" @click="onClickRegionMall">
						지자체몰
						<span>지역 특산품을 온라인으로 구매해보세요!</span>
					</button>
				</div>
				<div class="festival-swiper-controls" v-show="computedLocalEventList.length > 1">
					<swiper-controls :swiper="thisSwiper" :auto="true"></swiper-controls>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import Icon from '@/components/common/Icon';
import SwiperControls from '@/components/common/SwiperControls';

import { mapGetters } from 'vuex';
import { ACT_UPDATE_AR_EVENT_INQ_TMS } from '@/store/_act_consts';
import { MUT_SHOW_ALERT } from '@/store/_mut_consts';

export default {
	name: 'MapInfo',
	components: { Icon, SwiperControls },
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
		arDcdOptions: {
			type: Array,
			default: [],
		},
		localEventList: {
			type: Array,
			default: [],
		},
		localMallOnlyUrl: {
			type: String,
			default: '',
		},
		callAutoPlay: { 
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		thisSwiper: null,
		activeIndex: 0,
		swiperOption: {
			loop: false,
			// notNextTick: true,
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			},
			slidesPerView: 1,
			// loopedSlides: 0,
			spaceBetween: 40,
			touchRatio: 0.2,
			navigation: {
				nextEl: '.swiper-festival-container .swiper-button-next',
				prevEl: '.swiper-festival-container .swiper-button-prev',
			},
			pagination: {
				el: '.swiper-festival-container  .swiper-pagination',
				type: 'fraction',
			},
		},
	}),
	computed: {
		...mapGetters('common', ['isMobile', 'commonCode', 'campn']),
		...mapGetters('festival', []),

		campnId() {
			return this.campn.campnId;
		},
		computedLocalEventList() {
			return this.localEventList
		},
		regionMallUrl() {
			if (this.localMallOnlyUrl) return this.localMallOnlyUrl;
			if (this.computedLocalEventList && this.computedLocalEventList.length > 0) {
				const hasUrl = this.computedLocalEventList.find(item => item.localMallUrl);
				if (hasUrl) return hasUrl.localMallUrl;
			}
			return null;
		}
	},
	watch: {
		computedLocalEventList(newValue) {
			this.activeIndex = 0;
			this.$nextTick(() => {
				const swiperRef = this.$refs.swiper;
				if (!swiperRef || !swiperRef.$swiper) {
					this.thisSwiper = null;
					return;
				}
				
				this.thisSwiper = swiperRef.$swiper;
				const swiper = this.thisSwiper;
				swiper.slideTo(0, 0); // immediate slide
				
				setTimeout(() => {
					swiper.update();
					if (newValue.length > 1) {
						swiper.autoplay.start();
					} else {
						swiper.autoplay.stop();
					}
				}, 150);
			});
		},
	},
	created() { },
	mounted() {
		this.$nextTick(() => {
			if (this.$refs.swiper) {
				this.thisSwiper = this.$refs.swiper.$swiper;
			}
		});
	},
	methods: {

		// event ======================================================================
		onSwiperChange() {
			if (this.thisSwiper) {
				this.activeIndex = this.thisSwiper.realIndex;
			}
		},
		// gotoSwiper(idx) {
		// 	this.thisSwiper.slideTo(idx);
		// },
		onClickClose() {
			this.$emit('closeModal', false);
		},
		
		onClickMoveFestival(e, arevent) {

			// 1. URL 값이 있는지 먼저 확인 (null이나 undefined가 아닐 때만 실행)
			if (!arevent.rltdUrl) {
				this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
					title: `관련 링크가 등록되지 않았습니다.`,
					rightNow: true,
				});
				return;
			}

			const prefix = 'https://';
			let url = arevent.rltdUrl
			
			if (!url.startsWith(prefix)) {
				url = prefix + url;
			}
			window.open(url);
			
			this.updateArEventInqTms(arevent.arEventId)
		},

		openLocalMall() {
			if (this.localMallOnlyUrl) {
				const url = this.localMallOnlyUrl.startsWith('https://') ? this.localMallOnlyUrl : 'https://' + this.localMallOnlyUrl;
				window.open(url);
			}
		},

		onClickRegionMall() {
			if (this.regionMallUrl) {
				const url = this.regionMallUrl.startsWith('https://') ? this.regionMallUrl : 'https://' + this.regionMallUrl;
				window.open(url);
			}
		},

		// custom fn ==================================================================

		// promise ====================================================================
		async updateArEventInqTms(arEventId) {
			try {
				const params = {
					arEventId: arEventId, 
				}
				await this.$store.dispatch(`festival/${ACT_UPDATE_AR_EVENT_INQ_TMS}`, params)
			} catch (err) {
				console.error(err)
			}
        },
	},
};
</script>
